











































import { InvoiceCampaignEvent } from '@/types/InvoiceCampaign.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    props: {
        eventMessage: {
            type: Object as PropType<InvoiceCampaignEvent>,
            required: true
        }
    },
    data() {
        return {
            temp: null,
            days: ['On due date', 7, 14, 30, 60, 90],
            field: [
                {
                    text: 'Due date',
                    value: 'due_date'
                },
                {
                    text: 'Paid date',
                    value: 'paid_at'
                }
            ]
        }
    },
    mounted() {
        //  Clone our invoice campaign event so we do non-destructive editing
        this.temp = window._.cloneDeep(this.eventMessage)
    },
    computed: {
        when(): string[] {
            //  If no model yet, return nothing
            if (!this.temp) return null

            //  If field is paid_at, we can only handle "after" paid at date
            if (this.temp.field == 'paid_at') {
                //  Make sure 'After' is selected for user when they change field to 'Paid date'
                this.temp.when = 'After'

                return ['After']
            }

            //  Otherwise handle before or after due_date
            return ['Before', 'After']
        }
    },
    methods: {
        async save(): Promise<void> {
            //  Un-focus combobox to save current input
            if (this.$refs.comboBox) this.$refs.comboBox.blur()

            //  Validate v-combobox
            const valid = await this.$validator.validate()

            //  If not valid, prevent saving and do nothing
            if (!valid) return

            //  If valid, save eventMessage
            this.$emit('submit', this.temp)
        },
        updateDays(days: string): void {
            //  Numbers in the combobox are technically strings, we need to parse as int
            if (days != 'On due date') this.temp.days = parseInt(days)

            //  If selecting 'On due date', make sure field is set to due_date
            if (days == 'On due date') {
                this.temp.when = 'Before'
                this.temp.field = 'due_date'
            }
        }
    }
})
